import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';

import { DashboardGuard } from '@/components/common/DashboardGuard';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import AppAnalyticsInit from '@/lib/app-analytics-init';
import { FallbackPage } from '@/pages/Fallback';
import { AuthRoutes } from '@/routes/AuthRoutes';
import { DashboardRoutes } from '@/routes/DashboardRoutes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 3 * 60 * 1000,
    },
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        {/* FF-1129: App GA4 analytics — fires page_view on mount, no-ops
            when consent is suppressed (GPC/opt-out). Creds live in ff-backend. */}
        <AppAnalyticsInit />
        <Routes>
          <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
          <Route path="/:orgId/auth/*" element={<AuthRoutes />} />
          <Route path="/auth/*" element={<AuthRoutes />} />
          <Route
            path="/dashboard/*"
            element={
              <DashboardGuard>
                <DashboardRoutes />
              </DashboardGuard>
            }
          />
          <Route path="*" element={<FallbackPage />} />
        </Routes>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
};
